import type { IMpCombination } from '@/interface/IPopularMixParlay';
import type { RogueModelsResponsesPopularMixParlayResponse } from '@/interface/rogue';

export function formatMpRecommendation(response: RogueModelsResponsesPopularMixParlayResponse): IMpCombination[] {
    return (response.popularMixParlayBets ?? []).map(mp => ({
        key: (mp.popularMixParlaySubBets ?? []).map(sb => `${sb.eventId}-${sb.oddsId}-${sb.option}`).join('-'),
        subBetKeys: (mp.popularMixParlaySubBets ?? []).map(sb => ({
            key: `${sb.eventId}-${sb.oddsId}-${sb.option}`,
            eventId: sb.eventId ?? 0,
            oddsId: sb.oddsId ?? 0,
            option: (sb.option ?? '').toLowerCase(),
        })),
    }));
}
